import { Component } from "react";
import { Link } from "react-router-dom";




const subtitle = "United With Brands That Believe in Victory";
const title = "OUR PARTNERS";
const btnText = "BECOME A PARTNER";


let SponsorListContent = [
    {
        imgUrl: 'assets/images/sponsor/sponsor1.png',
        imgAlt: 'Sponsor Thumb',
    },
    {
        imgUrl: 'assets/images/sponsor/sponsor2.png',
        imgAlt: 'Sponsor Thumb',
    }
]



class SponsorSection extends Component {
    render() { 
        return (
            <div className="sponsor-section">
                <div className="container">
                    <div className="section-header">
                        <p >{subtitle}</p>
                        <h2 className="text-anim-typing  js-animate delay-md">{title}</h2>
                    </div>
                        <div className="row justify-content-center sponsor-row fade-left-overshoot fade-delay-1">
                        {/* FRUUM */}
                        <div className="col-auto">
                            <div className="sponsor-item">
                            <img
                                src="assets/images/sponsor/sponsor1.png"
                                alt="Fruum"
                                className="sponsor-logo sponsor-fruum"
                            />
                            </div>
                        </div>

                        {/* REMOTE INTEGRITY */}
                        <div className="col-auto">
                            <div className="sponsor-item">
                            <img
                                src="assets/images/sponsor/sponsor2.png"
                                alt="Remote Integrity"
                                className="sponsor-logo sponsor-remote"
                            />
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        );
    }
}
 
export default SponsorSection;